// extracted by mini-css-extract-plugin
module.exports = {"loaderHolder":"_13nWG","loader":"_3IIC2","rotate":"_3UO7p","reservationsHolder":"_1vn2w"};